import { useTranslation } from "react-i18next";
import { Seo } from "../components/layout/Seo";
import { Section } from "../components/ui/Section";
import { organization } from "../content/config";

export function Privacy() {
  const { t } = useTranslation();
  return (
    <>
      <Seo title="Privacy Policy" description="How submitted data and private documents are handled." />
      <Section title="Privacy Policy" intro="This page explains the categories of data collected through the website and the purposes of processing." className="pt-[calc(var(--header-height)+72px)]">
        <div className="max-w-3xl space-y-6 text-lg leading-8 text-ink-secondary">
          <p>Forms may collect business contact data, organization details, project context and private documents provided voluntarily for preliminary assessment or collaboration review.</p>
          <p>Submitted documents are intended for private review only. Public document URLs are not created. Analytics must not include names, emails, phone numbers, free-text form content or file names.</p>
          <p>Consent is required before submission. Eligibility, funding level, partnership status and financing conditions are never guaranteed by submitting a form.</p>
          <p>{organization.email ? `Questions can be sent to ${organization.email}.` : "A public contact email has not been configured yet."}</p>
        </div>
      </Section>
    </>
  );
}

export function Terms() {
  return (
    <>
      <Seo title="Terms" description="Website terms and responsible use limitations." />
      <Section title="Terms" intro="The website provides institutional information and preliminary inquiry flows. It does not provide legal, financial or engineering advice." className="pt-[calc(var(--header-height)+72px)]">
        <div className="max-w-3xl space-y-6 text-lg leading-8 text-ink-secondary">
          <p>Content is provided for informational purposes and may change as programmes, governance materials and confirmed public information evolve.</p>
          <p>No published page promises grants, fixed funding percentages, return on investment, official partnerships or guaranteed introductions.</p>
        </div>
      </Section>
    </>
  );
}

export function NotFound() {
  const { t } = useTranslation();
  return (
    <Section title="Page not found" intro="The page may have moved or may not exist in this locale." className="pt-[calc(var(--header-height)+72px)]">
      <a className="font-bold text-brand-blue" href="/en/">{t("nav.start")}</a>
    </Section>
  );
}
